// Generated by Melange

import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Buhta_landing__Api from "../../../../core/Api.js";
import * as Buhta_landing__ButtonPrimary from "../../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__Field from "../../../../components/landing/Field.js";
import * as Buhta_landing__I18n from "../../../../util/i18n/I18n.js";
import * as Buhta_models__Cms from "../../../../../../../packages/models/Cms.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function PricingContactForm(Props) {
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const match$1 = React.useState(function () {
    return "";
  });
  const setServiceType = match$1[1];
  const serviceType = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setName = match$2[1];
  const name = match$2[0];
  const match$3 = React.useState(function () {
    return "";
  });
  const setEmail = match$3[1];
  const email = match$3[0];
  const match$4 = React.useState(function () {
    return "";
  });
  const setPhone = match$4[1];
  const phone = match$4[0];
  const match$5 = React.useState(function () {
    return "";
  });
  const setCompany = match$5[1];
  const company = match$5[0];
  const match$6 = React.useState(function () {
    return "";
  });
  const setBin = match$6[1];
  const bin = match$6[0];
  const match$7 = React.useState(function () {
    return "";
  });
  const setQuestion = match$7[1];
  const question = match$7[0];
  const match$8 = React.useState(function () {
    return false;
  });
  const setLoading = match$8[1];
  const loading = match$8[0];
  const intl = ReactIntl.useIntl();
  const submit = function (ev) {
    const payload = {
      company: company,
      email: email,
      phone: phone,
      prefix: "",
      serviceType: serviceType,
      name: name,
      bin: bin,
      question: question
    };
    Curry._1(setLoading, (function (param) {
      return true;
    }));
    ev.preventDefault();
    const __x = Buhta_landing__Api.submitRequest(Buhta_models__Cms.$$Request.encode(payload));
    $$Promise.get(__x, (function (res) {
      if (res.TAG === /* Ok */ 0) {
        Curry._1(dispatchToasts, {
          TAG: /* Add */ 0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: "Заявка успешно доставлена",
            kind: "success",
            onClick: (function (param) {
              
            })
          }
        });
        Curry._1(setServiceType, (function (param) {
          return "";
        }));
        Curry._1(setName, (function (param) {
          return "";
        }));
        Curry._1(setCompany, (function (param) {
          return "";
        }));
        Curry._1(setEmail, (function (param) {
          return "";
        }));
        Curry._1(setPhone, (function (param) {
          return "";
        }));
        Curry._1(setBin, (function (param) {
          return "";
        }));
        Curry._1(setQuestion, (function (param) {
          return "";
        }));
      } else {
        Curry._1(dispatchToasts, {
          TAG: /* Add */ 0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: "Произошла ошибка. Попробуйте еще раз.",
            kind: "warning",
            onClick: (function (param) {
              
            })
          }
        });
      }
      Curry._1(setLoading, (function (param) {
        return false;
      }));
    }));
  };
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Консультации по бухгалтерскому учету и налогообложению",
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Заполните данные заявки.",
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsxs("form", {
        children: [
          JsxRuntime.jsx(Buhta_landing__Field.make, {
            label: "Вид услуги",
            name: "service_type",
            value: serviceType,
            onChange: (function (value) {
              Curry._1(setServiceType, (function (param) {
                return value;
              }));
            }),
            className: "h-14 border-b border-divider pb-2 mt-0",
            required: true,
            color: "text-gray-light-landing",
            topActive: "top-2",
            topPassive: "top-6",
            disabled: loading
          }),
          JsxRuntime.jsx(Buhta_landing__Field.make, {
            label: "ФИО",
            name: "name",
            value: name,
            onChange: (function (value) {
              Curry._1(setName, (function (param) {
                return value;
              }));
            }),
            className: "h-14 border-b border-divider pb-2 mt-2",
            required: true,
            color: "text-gray-light-landing",
            topActive: "top-2",
            topPassive: "top-6",
            disabled: loading
          }),
          JsxRuntime.jsx(Buhta_landing__Field.make, {
            label: "Email",
            type_: "email",
            name: "email",
            value: email,
            onChange: (function (value) {
              Curry._1(setEmail, (function (param) {
                return value;
              }));
            }),
            className: "h-14 border-b border-divider pb-2 mt-2",
            required: true,
            color: "text-gray-light-landing",
            topActive: "top-2",
            topPassive: "top-6",
            disabled: loading
          }),
          JsxRuntime.jsx(Buhta_landing__Field.make, {
            label: "Номер телефона",
            name: "phone",
            value: phone,
            onChange: (function (value) {
              Curry._1(setPhone, (function (param) {
                return value;
              }));
            }),
            className: "h-14 border-b border-divider pb-2 mt-2",
            required: true,
            color: "text-gray-light-landing",
            topActive: "top-2",
            topPassive: "top-6",
            disabled: loading
          }),
          JsxRuntime.jsx(Buhta_landing__Field.make, {
            label: "Наименование организации",
            name: "company",
            value: company,
            onChange: (function (value) {
              Curry._1(setCompany, (function (param) {
                return value;
              }));
            }),
            className: "h-14 border-b border-divider pb-2 mt-2",
            required: true,
            color: "text-gray-light-landing",
            topActive: "top-2",
            topPassive: "top-6",
            disabled: loading
          }),
          JsxRuntime.jsx(Buhta_landing__Field.make, {
            label: "БИН организации",
            name: "bin",
            value: bin,
            onChange: (function (value) {
              Curry._1(setBin, (function (param) {
                return value;
              }));
            }),
            className: "h-14 border-b border-divider pb-2 mt-2",
            required: true,
            color: "text-gray-light-landing",
            topActive: "top-2",
            topPassive: "top-6",
            disabled: loading
          }),
          JsxRuntime.jsx(Buhta_landing__Field.make, {
            label: "Ваш вопрос",
            name: "question",
            value: question,
            onChange: (function (value) {
              Curry._1(setQuestion, (function (param) {
                return value;
              }));
            }),
            className: "h-14 border-b border-divider pb-2 mt-2",
            required: true,
            color: "text-gray-light-landing",
            topActive: "top-2",
            topPassive: "top-6",
            disabled: loading
          }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "mt-6 lg:mt-10 w-full",
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "send_request"),
            type_: "submit",
            isDisabled: loading
          })
        ],
        className: "bg-bg rounded-lg mt-6 lg:mt-10 p-6 lg:p-10",
        onSubmit: submit
      })
    ],
    className: "pt-6 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = PricingContactForm;

export {
  make,
}
/* Buhta_core__Toast Not a pure module */
